import { z } from "zod";

export const schema = z.object({
    year: z.string().min(1, { message: 'Required' }),
    month: z.string().min(1, { message: 'Required' }),
    day: z.string().min(1, { message: 'Required' })
})